export default __webpack_public_path__ + "static/media/manage-bandwidth.0b773095.svg";